module.exports = __webpack_public_path__ + "img/cover.8e5b64c2.png";